<script>
    import { onMount, onDestroy } from "svelte";
    import * as Common from "../utiles/common.util";
    import { push } from "svelte-spa-router";
    import { PushNotifications } from "@capacitor/push-notifications";
    import { Capacitor } from "@capacitor/core";

    export let goBack;
    
    onMount(() => {
        // 로그인 상태 체크
        apiGetStatus();
    });

    async function apiGetStatus() {
        if (Capacitor.isNativePlatform()) {
            const permStatus = await PushNotifications.requestPermissions();

            if (permStatus.receive !== "granted") {
                // alert("푸시 알림 권한이 거부되었습니다.");
                return;
            }
        }

        const token = await Common.getStoredToken();

        if (token) {
            if (location.href.includes("Login")) {
                push("/AsList");
            }
        } else {
            if (!location.href.includes("Login")) {
                push("/Login");
            }
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<header class="header">
    <div class="mobile hd-title inner">
        <div class="hd-title-wrap">
            <img
                src="resource/img/ico_arrow_left.png"
                alt=""
                class="m-arrow-l"
                on:click={() => {
                    // history.back();
                    goBack();
                }}
            />
            <img
                src="resource/img/img_logo.png"
                alt=""
                class="m-logo m-logo-center"
                on:click={() => {
                    push("/Home");
                }}
            />
            <img
                src="resource/img/ico_home.png"
                alt=""
                class="m-cart"
                on:click={() => {
                    push("/Home");
                }}
            />
        </div>
    </div>
</header>
